import * as types from './types';
import * as htmlSanitize from 'src/helpers/htmlSanitize';

const defaultData = {
  steps: [
    {
      id: '',
      title: '-',
      quantity_of_answers: 0,
      options: [
        {
          label: '-',
          answers_count: 0,
        },
      ],
    },
  ],
};

export const state = {
  data: defaultData,
};

export const mutations = {
  [types.RESUME_SET_DATA](state, data) {
    data.steps = htmlSanitize.stepList(data.steps);
    state.data = data;
  },
  [types.RESUME_RESET_STATE](state) {
    state.resume = defaultData;
  },

  [types.RESUME_SET_DATE_FROM](state, dateFrom) {
    state.dateFrom = dateFrom;
  },

  [types.RESUME_SET_DATE_TO](state, dateTo) {
    state.dateTo = dateTo;
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/resume/mutations.js
 **/